import { lazy, Suspense } from "react";
import DotGridGlow from "@/components/DotGridGlow";
import Feet from "@/components/Feet";
import NewHeader from "@/components/NewHeader";
import OurProjects from "@/components/pages/home/OurProjects";
import BigEllipse from "@/components/svg/ellipse/BigEllipse";
import MediumEllipse from "@/components/svg/ellipse/MediumEllipse";

const WorkWithUs = lazy(() => import("@/components/WorkWithUs"));

export function Portfolio() {
  return (
    <div className="flex flex-col items-center justify-start bg-[#090910] gap-[100px] relative isolate overflow-clip">
      <DotGridGlow />
      <div className="absolute top-[-600px]">
        <MediumEllipse />
      </div>
      <div className="absolute top-[-0px] left-[-800px] pointer-events-none">
        <BigEllipse />
      </div>
      <NewHeader reflist={[]} />
      <OurProjects />
      <Suspense fallback={null}>
        <WorkWithUs />
      </Suspense>
      <Feet />
    </div>
  );
}
